import { z } from 'zod';

export const FrontendEnvSchema = z.strictObject({
  // Must prefix with VITE_ to be injected by Vite...
  VITE_AZURE_AD_TENANT_ID: z.string(),
  VITE_AZURE_AD_CLIENT_ID: z.string(),
  VITE_GOOGLE_MAPS_API_KEY: z.string(),
  VITE_RUM_APPLICATION_ID: z.string().optional(),
  VITE_RUM_IDENTITY_POOL_ID: z.string().optional(),
  VITE_RUM_GUEST_ROLE_ARN: z.string().optional(),
  VITE_RUM_REGION: z.string().optional(),
});
export type FrontendEnv = z.infer<typeof FrontendEnvSchema>;

// Define the config schema
export const ConfigSchema = FrontendEnvSchema.extend({
  STAGE: z.string(),
  PINO_LOG_LEVEL: z.enum(['info', 'debug', 'warn', 'error', 'fatal', 'silent']),
  APP_NAME: z.string(),
  AWS_ACCOUNT: z.string(),
  AWS_CLI_PROFILE: z.string().optional(),
  AWS_DOMAIN: z.string(),
  AWS_HOSTED_ZONE_DOMAIN: z.string().optional(),
  SECURITY_EMAIL: z.email(),
  AWS_REGIONS: z.string(),
  GITHUB_ORGANIZATION: z.string().min(1, 'GitHub organization is required'),
  GITHUB_REPOSITORY: z.string().min(1, 'GitHub repository is required'),
  SLACK_WEBHOOK_URL: z.string().url().optional(),
}); // Allow additional properties

export type Config = z.infer<typeof ConfigSchema>;

export const LambdaEnvSchema = ConfigSchema.extend({
  SQS_QUEUE_URL: z.string(),
  SQS_QUEUE_ARN: z.string(),
  SCHEDULE_ROLE_ARN: z.string(),
  KMS_KEY_ID: z.string(),
  DB_HOST: z.string(),
  S3_UPLOAD_BUCKET: z.string(),
  S3_UPLOAD_BUCKET_ARN: z.string(),
});

export type LambdaEnv = z.infer<typeof LambdaEnvSchema>;
